export default __webpack_public_path__ + "static/real_building-e36ac2b0333b0145ce2c71ab542b979f.png";